import { BrowserRouter, Route, Routes } from "react-router-dom";
import ROUTES from "./routes";
import AthleteprofilePage from "../pages/Athleteprofile/AthleteprofilePage";
import PostPage from "../pages/Post/PostPage";
import EventPage from "../pages/Event/EventPage";
import TeamprofilePage from "../pages/Teamprofile/TeamprofilePage";
import ChallengePage from "../pages/Challenge/ChallengePage";
import EarlyAccessPage from "../pages/EarlyAccess/EarlyAccessPage";
import HighlightPage from "../pages/Highlight/HighlightPage";
import HomePage from "../pages/Home/HomePage";
import { CheckApp } from "../components/topbanner";

const Router = () => {
  return (
    <BrowserRouter>
      <Routes>
        <Route element={<CheckApp />}>
          <Route index element={<HomePage />} />
          <Route
            path={ROUTES.ATHLETE_PROFILE}
            element={<AthleteprofilePage />}
          />
          <Route path={ROUTES.TEAM_PROFILE} element={<TeamprofilePage />} />
          <Route path={ROUTES.POST} element={<PostPage />} />
          <Route path={ROUTES.HIGHLIGHT} element={<HighlightPage />} />
          <Route path={ROUTES.EVENT} element={<EventPage />} />
          <Route path={ROUTES.CHALLENGE} element={<ChallengePage />} />
          <Route path={ROUTES.REACH_OUT} element={<EarlyAccessPage />} />
        </Route>
      </Routes>
    </BrowserRouter>
  );
};

export default Router;
